import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  hasError: {
    color: 'rgb(244, 67, 54)',
  },
  iconButton: {
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(1)} !important`,
    },
    '& *': {
      [theme.breakpoints.down('md')]: {
        fontSize: '1.35rem !important',
      },
    },
  },
}))
